module.exports = __webpack_public_path__ + "img/1-01.dd5c10dc.png";